import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const styles = {
  helperText: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    display: 'flex',
    height: '20px',
    marginBottom: '10px',
  },
  errorImage: {
    paddingRight: '4px',
  },
};

type FormHelperTextProps = { error?: boolean; message?: string } & WithStyles<typeof styles>;

const FormMessage = withStyles(styles)(({ error, message, classes }: FormHelperTextProps) => {
  return (
    <FormHelperText classes={{ root: classes.helperText }}>
      {error && <ErrorOutlineIcon className={classes.errorImage} fontSize="small" />}
      {message}
    </FormHelperText>
  );
});

export default FormMessage;
